<template>
  <div
    v-if="value"
    class="residential-account-shop-expires-at"
    :class="['residential-account-shop-expires-at--' + state]"
  >
    <template v-if="state !== 'expired'">{{ $t('deadline') }}: {{ value | Moment('D. MMM YYYY') }}</template>
    <template v-if="state === 'expired'">{{ $t('shopContractStatusExpired') }}</template>
    <FontAwesomeIcon v-if="['expired', 'critical'].includes(state)" :icon="['fal', 'calendar-exclamation']" />
  </div>
</template>

<script>
import moment from 'moment'
import { Moment } from '@/filters'

export default {
  props: {
    value: [Date, String],
  },
  computed: {
    state() {
      let date = moment(this.value)
      let diff = date.diff(moment(), 'days')

      if (date.isBefore(moment())) return 'expired'
      if (this.value && diff < 7) return 'critical'
      return 'default'
    },
  },
  filters: {
    Moment,
  },
}
</script>

<style lang="scss">
.residential-account-shop-expires-at {
  &--critical,
  &--expired {
    color: var(--error);
  }

  svg {
    margin-left: 5px;
  }
}
</style>
